import { useLayoutEffect, useEffect } from 'react';
var useIsoMorphicEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
export { useIsoMorphicEffect };